const apiUrl = process.env.REACT_APP_API_URL;

export async function GetEnviamentFiles(id: string) {
    const url = `${apiUrl}:8061/jutge/enviament/${id}/files`;
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
    });

    if (response.ok) {
        return await response.json();
    } else {
        return [];
    }
}
